/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs */

const en_shortcut_keys_ad_plugin_not_activated_error = /** @type {(inputs: Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Description Plugin Not Activated`)
};

const fr_shortcut_keys_ad_plugin_not_activated_error = /** @type {(inputs: Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin de description audio non active`)
};

const de_shortcut_keys_ad_plugin_not_activated_error = /** @type {(inputs: Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiobeschreibungs-Plugin nicht aktiviert`)
};

const it_shortcut_keys_ad_plugin_not_activated_error = /** @type {(inputs: Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin di descrizione audio non attivato`)
};

const ru_shortcut_keys_ad_plugin_not_activated_error = /** @type {(inputs: Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Плагин аудиоописания не активирован.`)
};

const es_shortcut_keys_ad_plugin_not_activated_error = /** @type {(inputs: Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin de descripción de audio no activado`)
};

const zh_cn2_shortcut_keys_ad_plugin_not_activated_error = /** @type {(inputs: Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频描述插件未激活`)
};

const ja_shortcut_keys_ad_plugin_not_activated_error = /** @type {(inputs: Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声解説プラグインが有効化されていません`)
};

const hi_shortcut_keys_ad_plugin_not_activated_error = /** @type {(inputs: Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण प्लगइन सक्रिय नहीं है`)
};

const pt_pt2_shortcut_keys_ad_plugin_not_activated_error = /** @type {(inputs: Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plugin de descrição de áudio não ativado`)
};

/**
* | output |
* | --- |
* | "Audio Description Plugin Not Activated" |
*
* @param {Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_ad_plugin_not_activated_error = /** @type {((inputs?: Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Ad_Plugin_Not_Activated_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_ad_plugin_not_activated_error(inputs)
	if (locale === "de") return de_shortcut_keys_ad_plugin_not_activated_error(inputs)
	if (locale === "it") return it_shortcut_keys_ad_plugin_not_activated_error(inputs)
	if (locale === "ru") return ru_shortcut_keys_ad_plugin_not_activated_error(inputs)
	if (locale === "es") return es_shortcut_keys_ad_plugin_not_activated_error(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_ad_plugin_not_activated_error(inputs)
	if (locale === "ja") return ja_shortcut_keys_ad_plugin_not_activated_error(inputs)
	if (locale === "hi") return hi_shortcut_keys_ad_plugin_not_activated_error(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_ad_plugin_not_activated_error(inputs)
	return en_shortcut_keys_ad_plugin_not_activated_error(inputs)
});